import {IProtocolStepStatus} from "@/protocols/types/protocol";

/**
 * Derive a GROUP step status from all member statuses.
 *
 * Rules:
 * - all skipped => skipped
 * - all completed/skipped with at least one completed => completed
 * - otherwise => incomplete
 */
export function deriveGroupStatusFromStatuses(
    memberStatuses: IProtocolStepStatus[],
): IProtocolStepStatus {
    if (memberStatuses.length === 0) {
        return IProtocolStepStatus.COMPLETED;
    }

    const allSkipped = memberStatuses.every((s) => s === IProtocolStepStatus.SKIPPED);
    const allCompletedOrSkipped = memberStatuses.every(
        (s) => s === IProtocolStepStatus.COMPLETED || s === IProtocolStepStatus.SKIPPED,
    );
    const hasCompleted = memberStatuses.some((s) => s === IProtocolStepStatus.COMPLETED);

    if (allSkipped) return IProtocolStepStatus.SKIPPED;
    if (allCompletedOrSkipped && hasCompleted) return IProtocolStepStatus.COMPLETED;
    return IProtocolStepStatus.INCOMPLETE;
}

